<mat-form-field
  class="w-100"
  [class.flat-mat-form-field]="flat"
  appearance="outline"
>
  <mat-label>{{ label }}</mat-label>
  <mat-select
    #select
    [formControl]="selectControl"
    (selectionChange)="onSelectionChange($event.value)"
    [placeholder]="defaultOptionText"
    (openedChange)="selectTriggered($event)"
    [disableOptionCentering]="true"
    [required]="required"
    [multiple]="multiple"
    [matTooltip]="getTitle()"
    [class.select-opened]="select.panelOpen"
  >
    <mat-option>
      <ngx-mat-select-search
        [showToggleAllCheckbox]="multiple"
        [toggleAllCheckboxIndeterminate]="isIndeterminate"
        [toggleAllCheckboxChecked]="isChecked"
        (toggleAll)="toggleSelectAll($event)"
        [formControl]="filterControl"
        [preventHomeEndKeyPropagation]="true"
        toggleAllCheckboxTooltipMessage="Selecionar tudo"
        placeholderLabel="Pesquisa"
        toggleAllCheckboxTooltipPosition="above"
      >
        <span ngxMatSelectNoEntriesFound> Nenhuma opção encontrada </span>
      </ngx-mat-select-search>
    </mat-option>

    @if (showDefaultOption) {
      <mat-option
        [value]="null"
        class="unselectable-option"
        [disabled]="disableDefaultOption"
        [class.text-muted]="disableDefaultOption"
      >
        {{ defaultOptionText }}
      </mat-option>
    }

    @if (showNone) {
      <mat-option [value]="0" class="unselectable-option">
        {{ "Nenhum" }}
      </mat-option>
    }

    @for (item of filteredOptions | async; track item) {
      <mat-option [value]="item.value">
        @if (!!optionTemplate) {
          <ng-container
            [ngTemplateOutlet]="optionTemplate"
            [ngTemplateOutletContext]="{ item }"
          >
          </ng-container>
        } @else {
          {{ item.text }}
        }
      </mat-option>
    }
  </mat-select>

  <span matTextSuffix class="cursor-pointer">
    @if (select.panelOpen) {
      <button
        (click)="select.close()"
        class="text-primary ms-1 px-0"
        style="border: none; background-color: transparent"
      >
        Ok
      </button>
    }
  </span>

  <mat-error>
    @if (control?.hasError("required")) {
      <span>Campo Obrigatório</span>
    }
  </mat-error>
</mat-form-field>
